/**
 * Notify the App that the User Has Logged In
 */
export function useLoggedIn() {
  window.dispatchEvent(new CustomEvent("userLoggedIn", {}));
}
